import { fg } from '@confluence/feature-gating';
import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';
import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';
import { differenceInDays, parseISO } from 'date-fns';

export const useIsConfluenceAutoprovisionEditionParity = () => {
	if (!fg('confluence_autoprovisioning_disable_premium_modal')) return false;

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const siteTraits = useSiteTraits({
		skipBootstrap: !UNSAFE_expValEqualsNoExposure(
			'confluence_autoprovisioning_edition_parity',
			'cohort',
			'variation',
		),
	});

	const isAutoProvisionedTrait = siteTraits?.data?.attributes?.find(
		(attribute) => attribute.name === 'is_jira_confluence_d0_auto-provisioned',
	);

	const autoProvisionedDateTrait = siteTraits?.data?.attributes?.find(
		(attribute) => attribute.name === 'confluence.auto-provision.activationDate',
	);

	if (
		!isAutoProvisionedTrait?.value ||
		!autoProvisionedDateTrait ||
		!UNSAFE_expValEqualsNoExposure(
			'confluence_autoprovisioning_edition_parity',
			'cohort',
			'variation',
		)
	) {
		return false;
	}

	try {
		return differenceInDays(new Date(), parseISO(autoProvisionedDateTrait.value)) <= 90;
	} catch {
		return false;
	}
};
